import { DOMAIN_NAME_PATTERN, SLUG_PATTERN } from '@cp/shared';

/**
 * Checks the forms make before sending, so the answer lands beside the field.
 * The patterns are the server's own (@cp/shared); the server checks again and
 * has the last word.
 */

export function isSlug(value: string): boolean {
  return SLUG_PATTERN.test(value);
}

export function isDomainName(value: string): boolean {
  return DOMAIN_NAME_PATTERN.test(value);
}

/** Shape only: whether the address can receive mail is the mail server's question. */
export function isEmail(value: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
}

/** A list typed into one field — commas, spaces, semicolons, new lines — as lowercase items. */
export function splitList(value: string): string[] {
  return value
    .split(/[\s,;]+/)
    .map((item) => item.trim().toLowerCase())
    .filter(Boolean);
}
